<template>
  <v-card>
    <v-card class="mb-5">
      <div class="d-flex justify-space-between align-center pa-4 container">
        <div>{{ section.title }}</div>
        <div>
          <v-btn color="primary" @click="$emit('close')">Close</v-btn>
        </div>
      </div>
    </v-card>
    <div class="container-size" :class="{ container: hurrybox || orderpolicy }" ref="sectionContainer">
      <div id="view-section-template" v-html="section.html"></div>
    </div>
  </v-card>
</template>
<script>
import { descriptionjs } from '../main';
export default {
  name: 'ViewSection',
  props: {
    section: {
      type: Object,
      required: true,
    },
    hurrybox: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    orderpolicy: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    open: {
      handler() {
        this.$nextTick(() => {
          const container = this.$refs.sectionContainer;
          if (!container) return;

          const scriptsSwiper = container.querySelector('script[data-attribute="script-swiper"]');

          if (scriptsSwiper) {
            const newScriptCDN = document.createElement('script');
            newScriptCDN.src = scriptsSwiper.getAttribute('src');
            newScriptCDN.setAttribute('data-ignore', 'true');

            newScriptCDN.onload = () => {
              runOtherScripts();
            };

            scriptsSwiper.parentNode.replaceChild(newScriptCDN, scriptsSwiper);
          } else {
            runOtherScripts();
          }

          function runOtherScripts() {
            const scripts = container.querySelectorAll('script:not([data-executed]):not([data-ignore])');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              for (const attr of script.attributes) newScript.setAttribute(attr.name, attr.value);
              newScript.text = script.textContent;
              script.parentNode.replaceChild(newScript, script);
              newScript.setAttribute('data-executed', '1');
            });
          }
          descriptionjs();
        });
      },
      immediate: true,
    },
  },
};
</script>
